module.exports = __webpack_public_path__ + "img/dfinitylogo.850dbeac.svg";